import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { productsService } from '../api/products.service';

/** Active products for subscription / company detail pickers. */
export function useActiveProductsCatalogQuery(enabled = true) {
  return useQuery({
    queryKey: queryKeys.products.catalogActive(),
    queryFn: () => productsService.list({ active: true, limit: 200 }).then((r) => r.data),
    enabled,
    staleTime: 30_000,
  });
}
